import { Component, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { DistrictNav } from './district-nav/district-nav';
import { DistrictAdminService } from '../../../services/district-admin.service.js';
import { School } from '../../../models/school';
import { DistrictStaff } from './district-staff/district-staff';
import { DistrictStaffDialogData } from './district-staff/district-staff';

@Component({
  selector: 'app-district-view',
  imports: [MatIconModule, FormsModule, CommonModule, DistrictNav],
  templateUrl: './district-view.html',
  styleUrl: './district-view.css',
})
export class DistrictView {
  private districtService = inject(DistrictAdminService);
  private title = inject(Title);
  private dialog: MatDialog = inject(MatDialog);

  schools = signal<School[]>([]);

  totalSchools = computed(() => this.schools().length);

  today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  /**
   * Sets the browser tab title on init and gets schools for users district
   * @returns {void}
   */
  ngOnInit(): void {
    this.title.setTitle('Dashboard | Handle');
    this.districtService.getSchools().subscribe({
      next: (schools) => {
        this.schools.set(schools);
      },
      error: (err) => console.error(err),
    });
  }

  /**
   * Opens dialog which displays all schools staff
   * @returns {void}
   */
  openStaffDialog(s: School): void {
    this.dialog.open(DistrictStaff, {
      data: { s } as DistrictStaffDialogData,
      width: '700px',
      maxWidth: '90vw',
      maxHeight: '700px',
    });
  }
}
